/**
File to organise pushing to git, getting repositories and creating a
new repository
*/
import { toGitRepoName } from '@/modules/globalModule/components/helperMethods';
import { Octokit } from '@octokit/core';

export const listGitRepos = async (token: string) => {
  const octokit = new Octokit({ auth: token });

  return await octokit.request(`GET /user/repos`, {
    type: 'all',
    headers: {
      accept: 'application/vnd.github+json',
      'X-GitHub-Api-Version': '2022-11-28'
    }
  });
};

/**
 * @param token
 * @param name
 * @param workspaceName
 * @returns
 */
export const createGitRepo = async (
  token: string,
  name: string,
  workspaceName: string
) => {
  const octokit = new Octokit({ auth: token });
  return await octokit.request('POST /user/repos', {
    name: name,
    description: `Git repository corresponding to the Miros workspace '${workspaceName}' `,
    homepage: 'https://github.com',
    private: false,
    is_template: true,
    auto_init: true,
    headers: {
      'X-GitHub-Api-Version': '2022-11-28'
    }
  });
};

export interface GitWorkspaceDetails {
  repoId: number;
  repoName: string;
  repoOwner?: string;
  branch?: string;
}
